var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-body",
    attrs: {
      "data-testid": "documents"
    }
  }, [(_vm.isInitial || _vm.isSaving) ? _c('form', {
    attrs: {
      "enctype": "multipart/form-data",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "dropbox"
  }, [_c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "name": _vm.uploadFieldName,
      "multiple": "",
      "disabled": _vm.isSaving,
      "data-testid": "document-upload"
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.name, $event.target.files)
      }
    }
  }), _vm._v(" "), (_vm.isInitial) ? _c('p', [_vm._v("\n                Sem přetáhni soubory, nebo kliknu pro nahrání\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('p', {
    attrs: {
      "data-testid": "document-upload-status"
    }
  }, [_vm._v("\n                Nahrávám " + _vm._s(_vm.fileCount) + " soubor...\n            ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('document-list', {
    attrs: {
      "reload": _vm.reloadList
    },
    on: {
      "listReloaded": function($event) {
        _vm.reloadList = false
      }
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86717aaa","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Document/DocumentComponent.vue
// module id = 600
// module chunks = 0